import { v4 as uuidv4 } from "uuid";

export default {
    methods: {
        /**
         * It gets the albums by email
         * @param {array} tags - []
         * @param {int} parkId
         * @param {date} visitDate - 2023-01-01(YYYY-MM-YY)
         */
        async getAlbumByTag(tags, parkId, visitDate, isUpdate = false) {
            try {
                this.$store.dispatch("setLoading", true);

                /* Creating an object with the parameters to send to the API. */
                const parameters = {
                    type: 1,
                    params: {
                        Tags: tags,
                        ParkID: parkId,
                        VisitDate: visitDate,
                    },
                };
                /* Calling the API to get the albums by email. */
                const response = await this.$store.dispatch(
                    "getAlbums",
                    parameters
                );
                
                // Validamos si hay algun error
                if (!response[0].PhotoExperiences.length) {
                    this.$store.dispatch("setLoading", false);
                    Vue.$toast.open({
                        message: this.$t(
                            "Validations.tag_dont_have_multimedios"
                        ),
                        type: "error",
                    });

                    return;
                }

                if (isUpdate) {
                    this.formatUpdateAlbumsByTag(response);
                } else {
                    /* Calling the function `formatAlbumsByEmail` and passing in the response from the API. */
                    this.formatAlbumsByTag(response);
                }

                const albumIdx = this.getIdxParksByDateAndParkId(
                    visitDate,
                    parkId
                );
                if (albumIdx > -1) {
                    this.$store.dispatch("removeItemByTagCart", {
                        visitDate,
                        parkId,
                    });
                }

                // We activate the tab to show the codes
                this.$store.dispatch("setTagsTab", true);
                this.$store.dispatch("setTypeCodeTab", 1);

                /* A method that is used to show a loading icon on the screen. */
                this.$store.dispatch("setLoading", false);

                /* Checking if the response from the API has data. If it does, it will redirect the
                user to the `albumes` route. */
                if (response.length && this.$route.name !== "albumes") {
                    this.$router.push({ name: "albumes" });
                }
            } catch (error) {
                this.$store.dispatch("setLoading", false);
                
            }
        },
        formatAlbumsByTag(data) {
            data.forEach((item) => {
                let album = {};
                const photoDetails = item.PhotoDetails;

                album.uuid = uuidv4();
                album.code = photoDetails.Tags[0];
                album.ParkID = photoDetails.ParkID;
                album.VisitDate = photoDetails.VisitDate;
                album.park = item.PhotoExperiences;
                album.Tags = this.removeDuplicates(photoDetails.Tags);
                album.Type = photoDetails.Type;

                // We store the album
                this.$store.dispatch("setAlbum", [album]);
            });
        },
        formatUpdateAlbumsByTag(data) {
            data.forEach((item) => {
                let album = {};
                const photoDetails = item.PhotoDetails;
                const idx = this.getIdxParksByUuid(this.deleteTags.uuid);

                album.uuid = this.deleteTags.uuid;
                album.code = photoDetails.Tags[0];
                album.ParkID = photoDetails.ParkID;
                album.VisitDate = photoDetails.VisitDate;
                album.park = item.PhotoExperiences;
                album.Tags = photoDetails.Tags;
                album.Type = photoDetails.Type;

                // We store the album
                this.$store.dispatch("refreshAlbum", { idx, data: album });
            });
        },
        groupParksByDate(tag, visitDate, parkId) {
            let albums = Object.values(this.$store.state.albumes);
            let parks = [];
            parks = albums
                .filter(
                    (item) =>
                        item.Type === 1 &&
                        item.ParkID === parseInt(parkId) &&
                        item.VisitDate === visitDate.toString()
                )
                .map((item) => item.Tags);

            

            const albumIdx = this.getIdxParksByDateAndParkId(visitDate, parkId);
            if (albumIdx > -1) {
                this.$store.dispatch("deleteAlbum", albumIdx);
            }

            let tags = parks.concat(tag).flat();
            

            return tags;
        },
        getIdxParksByDateAndParkId(date, parkId) {
            let idx = Object.values(this.$store.state.albumes).findIndex(
                (item) =>
                    item.Type === 1 &&
                    item.ParkID === parseInt(parkId) &&
                    item.VisitDate === date.toString()
            );

            return idx;
        },
        getIdxParksByUuid(uuid) {
            let idx = Object.values(this.$store.state.albumes).findIndex(
                (item) => item.Type === 1 && item.uuid === uuid.toString()
            );

            return idx;
        },
        removeDuplicates(arr) {
            return arr.filter((item, index) => arr.indexOf(item) === index);
        },
    },
};
